import { DASHBOARD_ONBOARDING_STEP_EVENTS, TStepInitialized } from './index';
import i18n, { defaultLang } from '@src/i18n';
import { trackByEvent } from '@src/tracking/services';
import { COMPONENT_TYPE } from '@src/tracking/constant';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';

export const useOnboardingTracking = () => {
  const { restaurant } = useKeycloakUserState();
  const trackStepInitialize = (stepNumber: number) => {
    try {
      const events = DASHBOARD_ONBOARDING_STEP_EVENTS as any;
      const { component_name = false, component_type = false } = events[`STEP_${stepNumber}`] || {};
      if (!component_name || !component_type) {
        return;
      }
      const trackData: TStepInitialized = {
        component_name,
        component_type: component_type as COMPONENT_TYPE,
        eventCategory: '',
        language: i18n.language || defaultLang,
        country: restaurant?.country || '',
      };
      trackByEvent<TStepInitialized>('banner_view', trackData);
    } catch (error) {
      console.log('trackStepInitialize error', error);
    }
  };

  const trackProductOverviewLink = () => {
    try {
      const { component_name, component_type, banner_action } =
        DASHBOARD_ONBOARDING_STEP_EVENTS.PRODUCT_OVERVIEW_LINK;
      const trackData: TStepInitialized = {
        component_name,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        eventCategory: '',
        language: i18n.language || defaultLang,
        country: restaurant?.country || '',
      };
      trackByEvent<TStepInitialized>('banner_select', trackData);
    } catch (error) {
      console.log('trackProductOverviewLink error', error);
    }
  };

  const trackReviewTutorial = () => {
    try {
      const { component_name, component_type, banner_action } =
        DASHBOARD_ONBOARDING_STEP_EVENTS.DIALOG_REVIEW_TUTORIAL;
      const trackData: TStepInitialized = {
        component_name,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        eventCategory: '',
        language: i18n.language || defaultLang,
        country: restaurant?.country || '',
      };
      trackByEvent<TStepInitialized>('banner_select', trackData);
    } catch (error) {
      console.log('trackProductOverviewLink error', error);
    }
  };

  const trackFinalTutorialDialogEnd = () => {
    try {
      const { component_name, component_type, banner_action } =
        DASHBOARD_ONBOARDING_STEP_EVENTS.DIALOG_FINAL_END;
      const trackData: TStepInitialized = {
        component_name,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        eventCategory: '',
        language: i18n.language || defaultLang,
        country: restaurant?.country || '',
      };
      trackByEvent<TStepInitialized>('banner_select', trackData);
    } catch (error) {
      console.log('trackProductOverviewLink error', error);
    }
  };

  const trackFinalTutorialDialogClose = () => {
    try {
      const { component_name, component_type, banner_action } =
        DASHBOARD_ONBOARDING_STEP_EVENTS.DIALOG_FINAL_CLOSE;
      const trackData: TStepInitialized = {
        component_name,
        component_type: component_type as COMPONENT_TYPE,
        banner_action,
        eventCategory: '',
        language: i18n.language || defaultLang,
        country: restaurant?.country || '',
      };
      trackByEvent<TStepInitialized>('banner_select', trackData);
    } catch (error) {
      console.log('trackProductOverviewLink error', error);
    }
  };

  return {
    trackStepInitialize,
    trackProductOverviewLink,
    trackReviewTutorial,
    trackFinalTutorialDialogEnd,
    trackFinalTutorialDialogClose,
  };
};

export default useOnboardingTracking;
